import script from "./EmployeeAddDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeAddDialog.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeAddDialog.vue?vue&type=style&index=0&id=edc1f506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edc1f506"]])

export default __exports__